(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tracking-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('input[name="tracking_number"]');
      const number = (input?.value || '').trim();
      if (!number) {
        input?.focus();
        return;
      }
      const base = form.dataset.providerUrl || 'https://t.17track.net/en#nums=';
      window.open(base + encodeURIComponent(number), '_blank', 'noopener');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
